export const PRIME_COLOR = '#2EB7FF';
export const PRIME_HOVER_COLOR = '#0099FE';

export const SECONDARY_COLOR = '#304156';
export const SECONDARY_HOVER_COLOR = '#000000';

export const BACK_COLOR = '#E1E5E9';
export const BACK_HOVER_COLOR = '#304156';

export const LINE_COLOR = '#E1E5E9';